import { render, staticRenderFns } from "./task-center.vue?vue&type=template&id=4664814e&scoped=true"
import script from "./task-center.vue?vue&type=script&lang=js"
export * from "./task-center.vue?vue&type=script&lang=js"
import style0 from "./task-center.vue?vue&type=style&index=0&id=4664814e&prod&lang=less&scoped=true"
import style1 from "./task-center.vue?vue&type=style&index=1&id=4664814e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4664814e",
  null
  
)

export default component.exports